import type { MaterialType, EventItem } from '../types';

export const materialMeta: Record<
  MaterialType,
  { label: string; icon: string; color: string }
> = {
  chat: { label: '聊天截图', icon: 'ri-chat-3-line', color: 'bg-secondary-100 text-secondary-900' },
  transfer: { label: '转账记录', icon: 'ri-bank-card-line', color: 'bg-accent-100 text-accent-800' },
  audio: { label: '录音文件', icon: 'ri-mic-line', color: 'bg-primary-100 text-primary-700' },
  video: { label: '影像片段', icon: 'ri-vidicon-line', color: 'bg-primary-100 text-primary-700' },
  doc: { label: '文档文件', icon: 'ri-file-text-line', color: 'bg-secondary-100 text-secondary-900' },
  social: { label: '社交动态', icon: 'ri-global-line', color: 'bg-accent-100 text-accent-800' },
};

export const statusStyle: Record<EventItem['status'], string> = {
  实锤: 'bg-primary-500 text-background-50',
  持续更新: 'bg-accent-600 text-background-50',
  辟谣中: 'bg-secondary-500 text-background-50',
  已辟谣: 'bg-background-200 text-foreground-700',
};

export function categoryOf(t: MaterialType): string {
  return materialMeta[t].label;
}